const getS3OriginIdFromUrl = (url?: string | null): string | null => {
  if (!url) {
    return null;
  }
  return url?.replace(/.*\//, '').replace(/\+.*/, '');
};

export default getS3OriginIdFromUrl;
